import * as types from "../../constants/actionTypes";
import { FORM_TYPE, GeneratedTemplateUploadStatus } from "../../constants/constants";
import { uploadLookupFileSuccess, uploadTemplateSuccess } from "../actions/NewTopologyActions";
import initialState from "./initialState";

export function topologyTypes(state = initialState.topologyTypes, action) {
  switch (action.type) {
    case types.FETCH_TOPOLOGY_TYPES_SUCCESS: {
      let topoTypes = action.topologyTypes
        ? action.topologyTypes.filter((t) => t.DisplayName.indexOf("*****") < 0 && t.TopologyManagements.some(topologyManagement => topologyManagement.Enabled))
        : [];
      return topoTypes;
    }
    default:
      return state;
  }
}

export function cloudTypesDefaultClassic(state = initialState.cloudTypesDefaultClassic, action) {
  switch (action.type) {
    case types.FETCH_CLOUD_TYPES_DEFAULT_CLASSIC_SUCCESS:
      return action.cloudTypesDefaultClassic;

    default:
      return state;
  }
}

export function customFormData(state = initialState.customFormData, action) {
  switch (action.type) {
    case uploadTemplateSuccess.type:
      return {
        ...state,
        show: true,
        template: action.payload.template,
        partnerId: action.payload.partnerId,
        environment: action.payload.environment,
        formType: FORM_TYPE.PRIVATE_TOPOLOGY,
      };
    case types.UPLOAD_TEMPLATE_FOR_LOOKUP_FILE_REQUESTED:
      return {
        ...state,
        templateForLookupFileUploaded: GeneratedTemplateUploadStatus.Uploading,
      };
    case types.UPLOAD_TEMPLATE_FOR_LOOKUP_FILE_ERROR:
      return {
        ...state,
        templateForLookupFileUploaded: GeneratedTemplateUploadStatus.UploadFailed,
      };
    case types.UPLOAD_TEMPLATE_FOR_LOOKUP_FILE_SUCCESS:
      return {
        ...state,
        show: false,
        template: action.returnValue.template,
        partnerId: action.returnValue.partnerId,
        environment: action.returnValue.environment,
        formType: FORM_TYPE.LOOKUP_TOPOLOGY,
        templateForLookupFileUploaded: GeneratedTemplateUploadStatus.UploadSucceeded,
      };
    case uploadLookupFileSuccess.type:
      return {
        ...state,
        show: true,
        template: action.payload.template,
        partnerId: action.payload.partnerId,
        environment: action.payload.environment,
        formType: FORM_TYPE.LOOKUP_TOPOLOGY,
      };
    case types.RESET_TEMPLATE_FOR_LOOKUP_FILE:
    case types.CLOSE_CREATE_PRIVATE_TOPOLOGY:
    case types.DEPLOY_PRIVATE_TEMPLATE_SUCCESS:
    case types.DEPLOY_LOOKUP_TOPOLOGY_TYPE_SUCCESS:
      return initialState.customFormData;

    default:
      return state;
  }
}

export function duplicateThresholdTopologies(state = initialState.duplicateThresholdTopologies, action) {
  switch (action.type) {
    case types.FETCH_DUPLICATE_THRESHOLD_TOPOLOGY_NAMES_SUCCESS:
      return action.duplicateThresholdTopologies;

    default:
      return state;
  }
}

export function userRegion(state = initialState.userRegion, action) {
  switch (action.type) {
    case types.GET_USER_REGION_SUCCESS:
      return {
        ...state,
        data: action.userRegion,
        isLoading: false,
        error: null,
        responseBody: null,
      };
    case types.GET_USER_REGION_REQUESTED:
      return {
        ...state,
        isLoading: true,
        error: null,
        responseBody: null,
      };
    case types.GET_USER_REGION_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error || action.message,
        responseBody: action.responseBody,
      };

    default:
      return state;
  }
}
